import { render, staticRenderFns } from "./EmailEndorsments.vue?vue&type=template&id=e29dc7f4&scoped=true&"
import script from "./EmailEndorsments.vue?vue&type=script&lang=js&"
export * from "./EmailEndorsments.vue?vue&type=script&lang=js&"
import style0 from "./EmailEndorsments.vue?vue&type=style&index=0&id=e29dc7f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29dc7f4",
  null
  
)

export default component.exports